import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(!click);
    // Toggle a CSS class on the body element to disable scrolling
    if (!click) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  };

  const closeMobileMenu = () => {
    setClick(false);
    // Remove the CSS class to enable scrolling when the menu is closed
    document.body.classList.remove('no-scroll');
  };

  return (
    <div>
<nav className='navbar'>
  <div className='navbar-container'>
    <Link to='/' className='navbar-logo'>
      <img src='../images/nav_logo.png' alt='quicklearn' width={60} /> Quicklearn
    </Link>

    <div className='menu-icon' onClick={handleClick}>
      <i style={{ color: "white" }} className={click ? 'fa fa-times' : 'fa fa-bars'} />
    </div>

    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
      <li className='nav-item' style={{ paddingLeft: '0rem' }}>
        <Link to='/' className='nav-links' onClick={closeMobileMenu}>
          Home
        </Link>
      </li>

      <li className='nav-item' style={{ paddingLeft: '0rem' }}>
        <Link to='/About' className='nav-links' onClick={closeMobileMenu}>
          About
        </Link>
      </li>

      <li className='nav-item' style={{ paddingLeft: '0rem' }}>
        <Link to='/Projects' className='nav-links' onClick={closeMobileMenu}>
          Projects
        </Link>
      </li>

      <li className='nav-item' style={{ paddingLeft: '0rem' }}>
        <div class="dropdown">
          <button class="btn btn dropdown-toggle" type="button" data-bs-toggle="dropdown" style={{ color: 'white' }}>
            More
          </button>
          <ul class="dropdown-menu">
            <li style={{ paddingLeft: '0rem' }}><a class="dropdown-item" href="SelectBranch">Notes</a></li>
            <li style={{ paddingLeft: '0rem' }}><a class="dropdown-item" href="SelectBranchB">Books</a></li>
            <li style={{ paddingLeft: '0rem' }}><a class="dropdown-item" href="SelectBranchP">Previous Year Paper</a></li>
          </ul>
        </div>
      </li>

      <li className='nav-item' style={{ paddingLeft: '0rem' }}>
        <Link
          to="/Contact"
          className='nav-links'
          rel="noreferrer"
          onClick={closeMobileMenu}
        >
          Contact
        </Link>
      </li>
    </ul>
  </div>
</nav>

    </div>
  );
}

export default Navbar;
